exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.collapsed > .when-open[data-v-738c3c01],\n:not(.collapsed) > .when-closed[data-v-738c3c01] {\n  display: none;\n}\n.collapsed > .when-closed[data-v-738c3c01],\n:not(.collapsed) > .when-open[data-v-738c3c01] {\n  display: inline;\n}\n.accordionToggle[data-v-738c3c01]:hover {\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-738c3c01","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/FormAccordion.vue
// module id = 1149
// module chunks = 2